/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * 課金期間タイプ
 */
export type TenantBillingPeriodTypeSchema =
  (typeof TenantBillingPeriodTypeSchema)[keyof typeof TenantBillingPeriodTypeSchema];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TenantBillingPeriodTypeSchema = {
  monthly: 'monthly',
  yearly: 'yearly',
} as const;
